<template>
  <div class="el-tabs__active-bar" :class="`is-${rootTabs.tabPosition}`" :style="barStyle"></div>
</template>
<script>
  export default {
    name: 'TabBar',
    props: {
      tabs: Array,
      currentName: String
    },
    inject: ['rootTabs'],
    watch: {
      currentName () {
        this.barStyle = this.createBarStyle()
      }
    },
    methods: {
      createBarStyle () {
        if (!this.$parent.$refs.tabs) {
          return {}
        }
        let style = {}
        let offset = 0
        let tabSize = 0
        const sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height'
        const sizeDir = sizeName === 'width' ? 'x' : 'y'
        const firstUpperCase = str => {
          return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        }
        this.tabs.every((tab, index) => {
          let $el = this.$parent.$refs.tabs[index]
          if (!$el) {
            return false
          }
          if (!tab.active) {
            offset += $el[`client${firstUpperCase(sizeName)}`]
            return true
          } else {
            tabSize = $el[`client${firstUpperCase(sizeName)}`]
            return false
          }
        })
        const transform = `translate${firstUpperCase(sizeDir)}(${offset + 20}px)`
        style[sizeName] = (tabSize ? tabSize - 40 : tabSize) + 'px'
        style.transform = transform
        style.msTransform = transform
        style.webkitTransform = transform
        return style
      }
    },
    data () {
      return {
        barStyle: {}
      }
    },
    mounted () {
      this.$nextTick(_ => {
        this.barStyle = this.createBarStyle()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/el-tabs/src/tab-bar.vue